import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Homepage from './Homepage';
import Dashboard from './private/Dashboard';
import Projects from './private/Projects';
import Services from './private/Services';
import Clients from './private/Clients';
import Profile from './private/Profile';
import Messages from './private/Messages';
import Login from './private/Login';
import AddReview from './public/AddReview';
import Reviews from './private/Reviews';

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Homepage />} />
          <Route path="/add-review" element={<AddReview />} /> 
          {/* Protected Routes */}
          <Route path="/reviews" element={<PrivateRoute><Reviews /></PrivateRoute>} />  {/* NEW */}
          <Route 
            path="/dashboard" 
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/projects" 
            element={
              <PrivateRoute>
                <Projects />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/clients" 
            element={
              <PrivateRoute>
                <Clients />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/messages" 
            element={
              <PrivateRoute>
                <Messages />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/services" 
            element={
              <PrivateRoute>
                <Services />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            } 
          />
          
          {/* Redirect root to dashboard
          <Route path="/" element={<Navigate to="/dashboard" replace />} /> */}
        </Routes>
      </Router>
    </AuthProvider>
  );
}
